module.exports = __webpack_public_path__ + "media/images/writer/follow_up_mailer/video_7-7e2f99e7edd2ac1858e0287cedca3f7c.png";